"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var assets_1 = __importDefault(require("./icons/assets"));
var Filter = function (_a) {
    var title = _a.title, onClick = _a.onClick, isActive = _a.isActive, slug = _a.slug, isSearchByProvider = _a.isSearchByProvider;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(isActive ? styles_module_scss_1.default.selected : '', " ").concat(isSearchByProvider ? styles_module_scss_1.default.lowOpacity : ''), onClick: function () { return onClick(slug); } },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.iconWrapper },
            react_1.default.createElement("img", { src: assets_1.default === null || assets_1.default === void 0 ? void 0 : assets_1.default[slug], alt: "icon" }),
            react_1.default.createElement("img", { src: assets_1.default === null || assets_1.default === void 0 ? void 0 : assets_1.default["".concat(slug, "Hover")], alt: "icon" })),
        react_1.default.createElement("h3", { className: styles_module_scss_1.default.title }, title)));
};
exports.default = Filter;
